import React from "react"
import { LOMA_DARK_TEAL, LOMA_GREEN, LOMA_GREEN_HOVER } from "../constants/colors"
import { Button, VStack, Text, Box } from "@chakra-ui/react"
import { motion } from "framer-motion"

const MotionBox = motion(Box);

export const ReadyToBuild = ({
    handleMainSubmit,
}: {
    handleMainSubmit: () => void;
}) => {
    return (
        <VStack spacing={4} align="stretch">
            <Text fontSize="md" color="gray.800" textAlign="center" mb={2}>
                Your email has been verified. Click or tap below to start the Loma AI generation process.
            </Text>

            <MotionBox
                width="full"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
            >
                <Button
                    size={{ base: "md", md: "lg" }}
                    width="full"
                    height={{ base: "48px", md: "56px" }}
                    bgGradient={`linear(135deg, #7BC9CC 0%, #357E81 100%)`}
                    color="white"
                    borderRadius={{ base: "12px", md: "16px" }}
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight="600"
                    onClick={handleMainSubmit}
                    _hover={{
                        bgGradient: `linear(135deg, #7BC9CC 0%, #357E81 100%)`,
                        transform: "translateY(-2px)",
                        boxShadow: `0 12px 24px -4px ${LOMA_GREEN}40`
                    }}
                    _loading={{
                        bgGradient: `linear(135deg, #7BC9CC 0%, #357E81 100%)`,
                        color: "white",
                        _hover: {
                          bgGradient: `linear(135deg, #7BC9CC 0%, #357E81 100%)`,
                        }
                    }}
                >
                    Build My Platform ✨
                </Button>
            </MotionBox>
        </VStack>
    )
}